import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * FormSubmitEvents
 *--------------------------------------------------------------------------
 *
 * Event to handle disabling the `submit` button of the form, and adding a class to display a loading indicator to the user
 *
 */
export default class FormSubmitEvents {

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/parameter-validator
	 */
	#validator;

	/**
	 * Form Element
	 *
	 * @var Element
	 */
	formElement;

	/**
	 * Form Submit Elements
	 *
	 * @var ElementList
	 */
	formSubmitElements;

	/**
	 * Class for when Form is Submitting
	 *
	 * @var String
	 */
	submittingClass;

	/**
	 * Create a new FormSubmitEvents object
	 *
	 * @param	Element		formElement			Element of the form that is being submitted.
	 * @param	ElementList	formSubmitElements	Submit button elements of the form. This will attempt to detect the elements in the `formElement` as the container.
	 * @param	String		submittingClass		Class to add to the `formSubmitElements` when form is submitting.
	 *
	 */
	constructor ({
		formElement = '',
		formSubmitElements = '[type="submit"], button:not([type])',
		submittingClass = 'g-button--submitting'
	} = {}) {
		this.#validator = new ParameterValidator(this);

		this.formElement = this.#validator.isElement('formElement', formElement);
		this.formSubmitElements = this.#validator.isElementList('formSubmitElements', formSubmitElements, {container: this.formElement});
		this.submittingClass = this.#validator.isString('submittingClass', submittingClass);

		this.init();
	}

	init () {
		this.resetFormSubmit();
		this.bindEvents();
	}

	bindEvents () {
		this.formElement.addEventListener('submit', () => this.handleSubmit());

		if (typeof window.navigation === 'object' && window.navigation instanceof window.Navigation) {
			window.navigation.addEventListener('navigateerror', () => {
				this.resetFormSubmit();
			});
		}
	}

	handleSubmit () {
		for (const formSubmitElement of this.formSubmitElements) {
			formSubmitElement.disabled = true;
			formSubmitElement.classList.add(this.submittingClass);
		}
	}

	resetFormSubmit () {
		for (const formSubmitElement of this.formSubmitElements) {
			if (formSubmitElement.classList.contains(this.submittingClass)) {
				formSubmitElement.removeAttribute('disabled');
				formSubmitElement.classList.remove(this.submittingClass);
			}
		}
	}

}
